import React, { Fragment, useEffect, useState } from "react";
import "../EMPAttendance/EMPattendance.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import Modal from "react-bootstrap/Modal";

import {
  Apiurl,
  GetLoginRole,
  GetToken,
  RemoveUserSession,
} from "../../../Utils/utils";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../../Components/loader/loader";
import { useNavigate } from "react-router-dom";
import fullday from "../../../Assets/Images/Present.png";
import holiday from "../../../Assets/Images/SatSun.png";
import leave from "../../../Assets/Images/FullDayLeave.png";
import shortleave from "../../../Assets/Images/shortleaveiconnew.png";
import HalfDayLeave from "../../../Assets/Images/HalfDayLeave.png";
import Properholiday from "../../../Assets/Images/Holiday.png";
import FloatingLabelInput from "../../../Components/floatingLabel/FloatingLabel";
import DatePicker from "react-multi-date-picker";
import { FaEdit } from "react-icons/fa";
import TimePicker from "react-multi-date-picker/plugins/time_picker";
import moment from "moment";
import OutDoorLeave from "../../../Assets/Images/OutDoorDuty.png";
import SickLeave from "../../../Assets/Images/SL.png";
import CasualLeave from "../../../Assets/Images/CLstar.png";
import { Button, Offcanvas } from "react-bootstrap";
import { IoIosFunnel } from "react-icons/io";

function OffCanvasExample({ setShow, show, setActiveButton, handleAttendanceSearch,currentDate,setSearchAttendance,searchAttendance, activeButton,handleClick ,name, ...props }) {

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Button className="HideButton-on-web" variant="primary" onClick={handleShow} >
      <IoIosFunnel />
      </Button>
      <Offcanvas className="Offcanvas-main-container" show={show} onHide={handleClose} {...props}>
        <Offcanvas.Header className="Offcanvas-outter-container" closeButton>
          <Offcanvas.Title>Offcanvas</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="Offcanvas-Body-container">
        <div className="Offcanvas-close-popup-forEMp-attendance">
  <div className="Offcanvas-Div" onClick={handleClose}></div>
          </div>
        <div className="EMP-search-filter-all-button-for-mobile-view">
                <button
                  className={`EMP-search-Filter-sheet-unactive ${
                    activeButton === 7 ? "active" : ""
                  }`}
                  onClick={() => handleClick(7)}
                  style={{
                    backgroundColor: activeButton === 7 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 7 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 7 Days
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${
                    activeButton === 30 ? "active" : ""
                  }`}
                  onClick={() => handleClick(30)}
                  style={{
                    backgroundColor:
                      activeButton === 30 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 30 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 30 Days
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${
                    activeButton === 90 ? "active" : ""
                  }`}
                  onClick={() => handleClick(90)}
                  style={{
                    backgroundColor:
                      activeButton === 90 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 90 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 3 Months
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${
                    activeButton === 180 ? "active" : ""
                  }`}
                  onClick={() => handleClick(180)}
                  style={{
                    backgroundColor:
                      activeButton === 180 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 180 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 6 Months
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${
                    activeButton === 365 ? "active" : ""
                  }`}
                  onClick={() => handleClick(365)}
                  style={{
                    backgroundColor:
                      activeButton === 365 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 365 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 12 Months
                </button>
              </div>
              <div className="calender-in-header-for-mobile-view row ">
                <div className="col-4">
                  <div className="EMP-flash-floating-sheet col">
                    <label htmlFor=""> Choose start date </label>
                    <input
                      type="date"
                      name=""
                      id=""
                      value={searchAttendance?.startDate}
                      onChange={(e) =>
                        setSearchAttendance({
                          ...searchAttendance,
                          startDate: e?.target?.value,
                        })
                      }
                      max={currentDate}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="flash-floating-sheet col">
                    <label htmlFor=""> Choose end date </label>
                    <input
                      type="date"
                      name=""
                      id=""
                      value={searchAttendance?.endDate}
                      // min={searchAttendance?.startDate}
                      onChange={(e) =>
                        setSearchAttendance({
                          ...searchAttendance,
                          endDate: e?.target?.value,
                        })
                      }
                      min={searchAttendance?.startDate}
                      max={currentDate}
                    />
                  </div>
                </div>
                {activeButton ||
                (searchAttendance?.startDate && searchAttendance?.endDate) ? (
                  <div className=" EMP-search-button-sheet col-4">
                    <button
                      onClick={() => {
                        setSearchAttendance({
                          startDate: "",
                          endDate: "",
                          dayscount: "",
                        });
                        setActiveButton();
                        handleAttendanceSearch();
                      }}
                    >
                      Reset
                    </button>
                  </div>
                ) : null}
              </div> 
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

const EMPattendance = () => {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const currentDate = new Date().toISOString().split("T")[0];
  const getUserRole = GetLoginRole();
  const [userNameHr, setUserNameHr] = useState();
  const [todayDate, setTodayDate] = useState(getTodayDate());
  const [showManualAttendance, setShowManualAttendance] = useState(false);
  const [updateAttend, setupdateAttend] = useState("");
  const [loading, setLoading] = useState(false);
  const [showSidebar, setShowSidebar] = useState(true);
  const [activeButton, setActiveButton] = useState();
  const [monthResult, setMonthResult] = useState();
  console.log(monthResult,"monthResult");
  const [searchAttendance, setSearchAttendance] = useState({
    startDate: "",
    endDate: "",
    dayscount: "",
  });
  const [inTimeHr, setInTimeHr] = useState();
  const [outTimeHr, setOutTimeHr] = useState();
  const [showModal, setShowModal] = useState(false);
  const [Modaldata, setmodaldata] = useState();
  const [modaldatanew, setmodaldatanew] = useState("");

  const handleCloseModal = () => {
    setShowModal(false);
  };
  const [hrAddingData, setHrAddingData] = useState({
    Username: "",
    date: todayDate,
    WorkDuration: "",
    Status: "",
  });

  useEffect(() => {
    if (userNameHr) {
      setHrAddingData({ ...hrAddingData, Username: userNameHr });
    }
  }, [userNameHr]);

  function getTodayDate() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  const handleClick = (index) => {
    setLoading(true);
    setShow(false)
    const data = {
      startDate: "",
      endDate: "",
      dayscount: index,
    };
    handleAttendanceSearch(data);
    setActiveButton(index);
  };

  const handleAttendanceSearch = (e) => {
    setLoading(true);
    const LoginToken = GetToken();
    const data = {
      startDate: e?.startDate || "",
      endDate: e?.endDate || "",
      dayscount: e?.dayscount || "",
    };
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/GetAttendanceByDateRange`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        setShow(false)
        const data = JSON.parse(e?.data?.data);
        const newData = data?.Result?.reduce((result, currentItem) => {
          const date = new Date(currentItem.Date);
          const month = date.getMonth() + 1;
          result[month - 1] = result[month - 1] || [];
          result[month - 1].push(currentItem);
          return result;
        }, []);
        const finalData = newData?.filter((item) => item?.length > 0);
        finalData.sort((a, b) => {
          const monthA = new Date(a[0].Date).getMonth();
          const monthB = new Date(b[0].Date).getMonth();
          const dayA = new Date(a[0].Date).getDate();
          const dayB = new Date(b[0].Date).getDate();
          if (monthA === monthB) {
            return dayB - dayA;
          }
          const currentDate = new Date();
          const currentMonth = currentDate.getMonth();
          if (monthA === currentMonth) {
            return -1;
          } else if (monthB === currentMonth) {
            return 1;
          }
          return monthB - monthA;
        });
        setMonthResult(finalData);
        if (e?.status === 200) {
          toast.success(e?.data?.message);
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
        if (  
          error?.message === "Network Error" &&
          error?.code === "ERR_NETWORK"
        ) {
          toast.error("Your Session has been expired");
          RemoveUserSession();
          navigate("/");
        }
      });
  };
  useEffect(() => {
    if (searchAttendance?.startDate && searchAttendance?.endDate) {
      setActiveButton(1);
      const data = {
        startDate: searchAttendance?.startDate,
        endDate: searchAttendance?.endDate,
        dayscount: "",
      };
      handleAttendanceSearch(data);
    } else {
      handleAttendanceSearch();
    }
  }, [searchAttendance?.endDate]);
  const monthsArray = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handleAddInputsClick = () => {
    setShowManualAttendance(true);
  };
  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);

  const handleAttendanceAdd = (e) => {
    e?.preventDefault();
    setLoading(true);
    const LoginToken = GetToken();
    const data = {};
    data.UserName = hrAddingData?.Username;
    data.InTime = moment(new Date(inTimeHr)).format("HH:mm:ss.SS");
    data.OutTime = moment(new Date(outTimeHr)).format("HH:mm:ss.SS");
    data.Date = hrAddingData?.date;
    data.IsUrgentWork = "true";

    const inTime = moment(data.InTime, "HH:mm:ss.SS");
    const outTime = moment(data.OutTime, "HH:mm:ss.SS");
    const durationInMilliseconds = outTime.diff(inTime);
    const hours = Math.floor(durationInMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor(
      (durationInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((durationInMilliseconds % (1000 * 60)) / 1000);
    const milliseconds = durationInMilliseconds % 1000;
    const workDuration = `${hours}:${minutes}:${seconds}.${milliseconds}`;
    data.WorkDuration = workDuration;
    if (data.InTime && data.OutTime) {
      data.Status = "Present";
    } else {
      data.Status = "Absent";
    }
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/SaveAttendance`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        handleAttendanceSearch();
        setOutTimeHr("");
        setInTimeHr("");
      })

      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };

  const handleAttendanceUpdate = (e) => {
    e?.preventDefault();
    setLoading(true);
    const LoginToken = GetToken();
    const data = {};
    data.UserName = hrAddingData?.Username;
    data.InTime = moment(new Date(inTimeHr)).format("HH:mm:ss.SS");
    data.OutTime = moment(new Date(outTimeHr)).format("HH:mm:ss.SS");
    data.Date = hrAddingData?.date;
    const inTime = moment(data.InTime, "HH:mm:ss.SS");
    const outTime = moment(data.OutTime, "HH:mm:ss.SS");
    const durationInMilliseconds = outTime.diff(inTime);
    const hours = Math.floor(durationInMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor(
      (durationInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((durationInMilliseconds % (1000 * 60)) / 1000);
    const milliseconds = durationInMilliseconds % 1000;
    const workDuration = `${hours}:${minutes}:${seconds}.${milliseconds}`;
    data.WorkDuration = workDuration;
    if (data.InTime && data.OutTime) {
      data.Status = "Present";
    } else {
      data.Status = "Absent";
    }
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/SaveAttendance`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);
        const data = JSON.parse(e?.data?.data);
        handleAttendanceSearch();
        setOutTimeHr("");
        setInTimeHr("");
      })

      .catch((err) => {
        setLoading(false);
        toast.error(err?.response?.data?.message);
      });
  };
  // useEffect(() => {
  //   handleAttendanceUpdate();
  // }, []);
  const handleEditModal = (item) => {
    setupdateAttend(item);
    const timeToString = (e) => {
      const timeString = e;
      const timeArray = timeString.split(":");
      const date = new Date();
      date.setHours(parseInt(timeArray[0], 10));
      date.setMinutes(parseInt(timeArray[1], 10));
      date.setSeconds(parseInt(timeArray[2], 10));
      return date;
    };

    const inTime = timeToString(item.InTime);
    const outTime = timeToString(item.OutTime);
    setmodaldata(inTime);
    setmodaldatanew(outTime);
    setShowModal(true);
  };
  const handleUpdateAttendance = () => {
    const LoginToken = GetToken();

    const data = {};
    data.Id = updateAttend.Id;
    data.InTime = moment(new Date(Modaldata)).format("HH:mm:ss.SS");
    data.OutTime = moment(new Date(modaldatanew)).format("HH:mm:ss.SS");
    data.Date = updateAttend.Date;
    const inTime = moment(Modaldata, "HH:mm:ss.SS");
    const outTime = moment(modaldatanew, "HH:mm:ss.SS");
    const durationInMilliseconds = outTime.diff(inTime);
    const hours = Math.floor(durationInMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor(
      (durationInMilliseconds % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((durationInMilliseconds % (1000 * 60)) / 1000);
    const milliseconds = durationInMilliseconds % 1000;
    const workDuration = `${hours}:${minutes}:${seconds}.${milliseconds}`;
    data.WorkDuration = workDuration;
    if (data.InTime && data.OutTime) {
      data.Status = "Present";
    } else {
      data.Status = "Absent";
    }
    setLoading(true);
    const option = {
      method: "POST",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Attendence/SaveAttendance`,
      data: { data: JSON.stringify(data) },
    };
    axios(option)
      .then((e) => {
        setLoading(false);

        if (e?.status === 200) {
          toast.success(e?.data?.message);
          setShowModal(false);
          handleAttendanceSearch();
        }
      })
      .catch((error) => {
        setLoading(false);
        toast.error(error?.response?.data?.message);
      });
  };
  return (
    <div>
      {loading ? <Loader /> : null}
      <Header
        showSidebar={showSidebar}
        setShowSidebar={setShowSidebar}
        setUserNameHr={setUserNameHr}
      />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />
        <div
          className={
            showSidebar
              ? "EMP-main-container-of-all-employees-sheet"
              : "EMP-main-container-of-all-employees-page-new-sheet"
          }
        >
          <div className="EMP-inner-container-of-all-employees-page ">
            <div className="header-of-employees-page row">
              <div className="EMP-all-employee-sheet col">
                <h4>Attendance Sheet</h4>
                <OffCanvasExample currentDate={currentDate} setActiveButton={setActiveButton} handleAttendanceSearch={handleAttendanceSearch}
                   setSearchAttendance={setSearchAttendance}
                    searchAttendance={searchAttendance}  show={show} setShow={setShow}
                    handleClick={handleClick} activeButton={activeButton}  placement="bottom" name="Open Bottom" />
              </div>
              <div className="EMP-all-employees-sheet col">
                <div className="EMP-home-icon-sheet">
                  <BiHomeAlt className="EMP-home-icon-header-sheet" />
                </div>
                <div className="EMP-arrow-icon-sheet">
                  <MdKeyboardArrowRight />
                </div>
                <div className="EMP-employee-text-sheet">
                  <p>Attendance</p>
                </div>
                <div className="EMP-arrow-icon-sheet">
                  <MdKeyboardArrowRight />
                </div>
                <div className="EMP-all-employee-text-sheet">
                  <p>Attendance Sheet</p>
                </div>
              </div>
            </div>
          </div>
          <div className="EMP-body-part-outer-sheet">
            <div className="EMP-table-in-all-emplyee-sheet">
              <div className="EMP-attandance-sheet-head">
                <div className="top-legends-main">
                  <div className="attendance-sheet-before-legends">
                    <h2>Attendance Sheet</h2>
                  </div>
                  <div className="legends-section">
                    <div className="legends-inner">
                      <img
                        src={fullday}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">P</p>
                    </div>
                    <div className="legends-inner">
                      <img
                        src={holiday}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">Off</p>
                    </div>
                    <div className="legends-inner">
                      <img
                        src={Properholiday}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">H</p>
                    </div>
                    <div className="legends-inner">
                      <img src={leave} alt="image" className="legends-images" />
                      <p className="legends-names">A</p>
                    </div>
                    <div className="legends-inner">
                      <img
                        src={HalfDayLeave}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">HDL</p>
                    </div>
                    <div className="legends-inner">
                      <img
                        src={shortleave}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">SDL</p>
                    </div>

                    <div className="legends-inner">
                      <img
                        src={OutDoorLeave}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">ODL</p>
                    </div>

                    <div className="legends-inner">
                      <img
                        src={SickLeave}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">SL</p>
                    </div>

                    <div className="legends-inner">
                      <img
                        src={CasualLeave}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">CL</p>
                    </div>
                  </div>
                </div>
                {/* <div className="top-legends-main">
                  <div className="attendance-sheet-before-legends">
                    <h2>Attendance Sheet</h2>
                  </div>
                  <div className="legends-section">
                    <div className="legends-inner">
                      <img
                        src={fullday}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">Present</p>
                    </div>

                    <div className="legends-inner">
                      <img
                        src={holiday}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">Off Day</p>
                    </div>

                    <div className="legends-inner">
                      <img
                        src={Properholiday}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">Holiday</p>
                    </div>

                    <div className="legends-inner">
                      <img src={leave} alt="image" className="legends-images" />
                      <p className="legends-names">Leave</p>
                    </div>
                    <div className="legends-inner">
                      <img
                        src={HalfDayLeave}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">Half Day Leave</p>
                    </div>
                    <div className="legends-inner">
                      <img
                        src={shortleave}
                        alt="image"
                        className="legends-images"
                      />
                      <p className="legends-names">Short Leave</p>
                    </div>
                  </div>
                </div> */}
              </div>
              <div className="EMP-search-filter-all-button">
                <button
                  className={`EMP-search-Filter-sheet-unactive ${
                    activeButton === 7 ? "active" : ""
                  }`}
                  onClick={() => handleClick(7)}
                  style={{
                    backgroundColor: activeButton === 7 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 7 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 7 Days
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${
                    activeButton === 30 ? "active" : ""
                  }`}
                  onClick={() => handleClick(30)}
                  style={{
                    backgroundColor:
                      activeButton === 30 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 30 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 30 Days
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${
                    activeButton === 90 ? "active" : ""
                  }`}
                  onClick={() => handleClick(90)}
                  style={{
                    backgroundColor:
                      activeButton === 90 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 90 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 3 Months
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${
                    activeButton === 180 ? "active" : ""
                  }`}
                  onClick={() => handleClick(180)}
                  style={{
                    backgroundColor:
                      activeButton === 180 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 180 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 6 Months
                </button>
                <button
                  className={`EMP-search-Filter-sheet-unactive ${
                    activeButton === 365 ? "active" : ""
                  }`}
                  onClick={() => handleClick(365)}
                  style={{
                    backgroundColor:
                      activeButton === 365 ? "#3f51b5" : "#ffffff",
                    color: activeButton === 365 ? "#ffffff" : "#171718",
                  }}
                >
                  Last 12 Months
                </button>
              </div>
              <div className="calender-in-header row ">
                <div className="col-4">
                  <div className="EMP-flash-floating-sheet col">
                    <label htmlFor=""> Choose start date </label>
                    <input
                      type="date"
                      name=""
                      id=""
                      value={searchAttendance?.startDate}
                      onChange={(e) =>
                        setSearchAttendance({
                          ...searchAttendance,
                          startDate: e?.target?.value,
                        })
                      }
                      max={currentDate}
                    />
                  </div>
                </div>
                <div className="col-4">
                  <div className="flash-floating-sheet col">
                    <label htmlFor=""> Choose end date </label>
                    <input
                      type="date"
                      name=""
                      id=""
                      value={searchAttendance?.endDate}
                      // min={searchAttendance?.startDate}
                      onChange={(e) =>
                        setSearchAttendance({
                          ...searchAttendance,
                          endDate: e?.target?.value,
                        })
                      }
                      min={searchAttendance?.startDate}
                      max={currentDate}
                    />
                  </div>
                </div>
                {activeButton ||
                (searchAttendance?.startDate && searchAttendance?.endDate) ? (
                  <div className=" EMP-search-button-sheet col-4">
                    <button
                      onClick={() => {
                        setSearchAttendance({
                          startDate: "",
                          endDate: "",
                          dayscount: "",
                        });
                        setActiveButton();
                        handleAttendanceSearch();
                      }}
                    >
                      Reset
                    </button>
                  </div>
                ) : null}
              </div>  

            


              {/* {getUserRole === "HR" && !showManualAttendance ? (
                <button
                  className="adding-attendance"
                  onClick={handleAddInputsClick}
                >
                  Add Attendance Manually
                </button>
              ) : null} */}

              {/* {showManualAttendance ? (
                <div className="inputs-for-hr-data-entry row ">
                  <div className="username-name-hr col-3">
                    <label htmlFor="">User Name</label>
                    <input
                      type="text"
                      value={hrAddingData?.Username}
                      onChange={(e) =>
                        setHrAddingData({
                          ...hrAddingData,
                          Username: e?.target?.value,
                        })
                      }
                    />
                  </div>
                  <div className="date-hr col-3">
                    <label htmlFor="">Date </label>
                    <input
                      type="date"
                      value={hrAddingData?.date}
                      onChange={(e) =>
                        setHrAddingData({
                          ...hrAddingData,
                          date: e?.target?.value,
                        })
                      }
                      max={currentDate}
                    />
                  </div>
                  <div className="in-time-div-hr-screen col-2">
                    <label htmlFor="">In Time</label>
                    <DatePicker
                      value={inTimeHr}
                      disableDayPicker
                      className="time-picker-in-hr-portal"
                      format="hh:mm A"
                      plugins={[<TimePicker />]}
                      onChange={(date) => setInTimeHr(date)}
                    />
                  </div>
                  <div className="in-time-div-hr-screen col-2">
                    <label htmlFor="">Out Time</label>
                    <DatePicker
                      className="time-picker-in-hr-portal"
                      value={outTimeHr}
                      disableDayPicker
                      format="hh:mm A"
                      plugins={[<TimePicker />]}
                      onChange={(date) => setOutTimeHr(date)}
                    />
                  </div>
                  <div className="submit-attendance-button col-1">
                    <button onClick={handleAttendanceAdd}>Submit</button>
                  </div>
                </div>
              ) : null} */}

              <div className="EMP-table-all-content-sheet">
                {monthResult?.map((e, index) => {
                  return (
                    <Fragment key={index}>
                      <div className="months-heading-for-table">
                        <p>
                          {`${
                            monthsArray[new Date(e?.[0]?.Date)?.getMonth()]
                          } ${new Date(e?.[0]?.Date)?.getFullYear()}`}
                        </p>
                      </div>
                      <table className="EMP-table-main-class">
                        <thead className="EMP-thead-main-class">
                          <tr className=" ewfef row"></tr>
                          <tr className="">
                            <th className="day-and-date-label">
                              <p>Date</p>
                              <p>Day</p>
                            </th>
                            {e?.map((item, index) => (
                              <td key={index} className=" ">
                                {new Date(item?.Date)?.toLocaleDateString(
                                  "en-US",
                                  { weekday: "short", day: "numeric" }
                                )}
                              </td>
                            ))}
                          </tr>
                        </thead>
                        <tbody className="EMP-tbody-main-class">
                          <tr>
                            <td className="input-class-in-td-main ">
                              <p className="attendance-label">Attendance</p>
                              <p className="in-time-label">In time</p>
                              <p className="outtime-label">Out time</p>
                            </td>
                            {e?.map((item, index) => (
                              <td key={index} className={item.Status === "WeeklyOFF" ? "SetIcons-at-the-top" : ""}>
                                <p className="star-for-attendance"></p>

                                   {item.DailyStatus ===  "WeeklyOFF" &&(
                                       <img
                                       src={holiday}
                                       alt="image"
                                       className="legends-images"
                                     />
                                   )}
                                   {item.DailyStatus ===  "SickLeave" &&(
                                       <img
                                       src={SickLeave}
                                       alt="image"
                                       className="legends-images"
                                     />
                                   )}
                                    {item?.DailyStatus ===
                                            "CasualLeave" && (
                                            <img
                                              src={CasualLeave}
                                              alt="image"
                                              className="legends-images"
                                            />
                                          )}
                                                {item?.DailyStatus === "Holiday" && (
                                            <img
                                              src={Properholiday}
                                              alt="image"
                                              className="legends-images"
                                            />
                                          )}
                                      {item?.DailyStatus === "Absent" &&  
                                      item.DailyStatus !== "WeeklyOff" && (
                                        <img 
                                          src={leave}
                                          alt="Leave"
                                          className= {item.Status=== "Absent"?  "SetIcons-at-the-top" :"legends-images"}
                                        />
                                      )}
                                {item?.DailyStatus?.length ? (
                                  <>
                                    {item?.DailyStatus === "ShortLeave" && (
                                      <img
                                        src={shortleave}
                                        alt="image"
                                        className="legends-images"
                                      />
                                    )}
                                    {item?.DailyStatus === "FullDay" && (
                                      <img
                                        src={fullday}
                                        alt="image"
                                        className="legends-images"
                                      />
                                    )}
                                    {/* {item.Status === "WeeklyOff" && (
                                      <img
                                        src={holiday}
                                        alt="image"
                                        className="legends-images"
                                      />
                                    )} */}
                                    {/* {item?.DailyStatus === "Leave" &&
                                      item.Status !== "WeeklyOff" && (
                                        <img
                                          src={leave}
                                          alt="Leave"
                                          className="legends-images"
                                        />
                                      )} */}
                                    {item.DailyStatus === "EarlyClosure" && (
                                      <img
                                        src={fullday}
                                        alt="image"
                                        className="legends-images"
                                      />
                                    )}
                                    {item.DailyStatus === "HalfDayleave" && (
                                      <img
                                        src={HalfDayLeave}
                                        alt="image"
                                        className="legends-images"
                                      />
                                    )}
                                    {(item.DailyStatus === "ShortLeave") ===
                                      2 && (
                                      <img
                                        src={HalfDayLeave}
                                        alt="image"
                                        className="legends-images"
                                      />
                                    )}
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    <div className="legends-images-new"> .</div>
                                  </>
                                )}

                                <p className="intime-for-attendance">
                                  {item?.InTime
                                    ? item?.InTime.substring(0, 5)
                                    : "-"}
                                </p>
                                <p className="out-for-attendance">
                                  {item?.OutTime
                                    ? item?.OutTime.substring(0, 5)
                                    : "-"}
                                </p>
                              </td>
                            ))}
                          </tr>
                        </tbody>
                      </table>
                    </Fragment>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal show"
        style={{ display: "block", position: "initial" }}
      >
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title> Edit time</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div className="date-hr-modal-manually ">
              <label htmlFor="">Date </label>
              <DatePicker
                containerClassName="containerclass"
                value={new Date(updateAttend.Date)}
                onChange={(date) => {}}
              />
            </div>
            <div className="update-attendance-time">
              <div className="inTime-employee-attendance">
                <label htmlFor="">In Time</label>
                <DatePicker
                  className="time-change-in-hr-side"
                  value={Modaldata}
                  format="hh:mm A"
                  plugins={[<TimePicker />]}
                  disableDayPicker
                  onChange={(date) => setmodaldata(new Date(date))}
                />
              </div>
              <div className="inTime-employee-attendance">
                <label htmlFor="">Out Time</label>

                <DatePicker
                  plugins={[<TimePicker />]}
                  format="hh:mm A"
                  className="time-change-in-hr-side"
                  value={modaldatanew}
                  disableDayPicker
                  onChange={(date) => setmodaldatanew(new Date(date))}
                />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <button
              variant="secondary"
              onClick={handleCloseModal}
              className="close-button-modal-hr"
            >
              Close
            </button>
            <button
              variant="primary"
              onClick={handleUpdateAttendance}
              className="save-button-modal-hr"
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  );
};
export default EMPattendance;
